var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ApplicationWrapper",
    {
      attrs: { hideHeader: true, showTwoActionLines: this.showTwoActionLines },
      on: { "update:actionArea": _vm.handleActionAreaChanged },
    },
    [
      _c(
        "template",
        { slot: "details" },
        [
          _c(
            "Detail",
            { staticClass: "text-center mt-4" },
            [
              _c(
                "template",
                { slot: "header" },
                [
                  _vm.paymentOption == _vm.PAYMENTOPTION_PAYPAL ||
                  _vm.paymentOption == _vm.PAYMENTOPTION_KLARNA
                    ? _c("v-list-item-title", [
                        _vm.type == _vm.TYPE_COURSES
                          ? _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("payment.successMessage", [
                                    _vm.$t("common.article_des"),
                                    _vm.$t("common.label_courses"),
                                    _vm.bookedTitle,
                                  ])
                                ),
                              },
                            })
                          : _vm._e(),
                        _vm.type == _vm.TYPE_HALLS
                          ? _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("payment.successMessage", [
                                    _vm.$t("common.article_der"),
                                    _vm.$t("common.label_hall"),
                                    _vm.bookedTitle,
                                  ])
                                ),
                              },
                            })
                          : _vm._e(),
                      ])
                    : _c("v-list-item-title", [
                        _vm.type == _vm.TYPE_COURSES
                          ? _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t(
                                    "payment.successMessageClubAccounting",
                                    [
                                      _vm.$t("common.article_des"),
                                      _vm.$t("common.label_courses"),
                                      _vm.bookedTitle,
                                    ]
                                  )
                                ),
                              },
                            })
                          : _vm._e(),
                        _vm.type == _vm.TYPE_HALLS
                          ? _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t(
                                    "payment.successMessageClubAccounting",
                                    [
                                      _vm.$t("common.article_der"),
                                      _vm.$t("common.label_hall"),
                                      _vm.bookedTitle,
                                    ]
                                  )
                                ),
                              },
                            })
                          : _vm._e(),
                      ]),
                  _c("br"),
                  _vm.paymentOption == _vm.PAYMENTOPTION_PAYPAL ||
                  _vm.paymentOption == _vm.PAYMENTOPTION_KLARNA
                    ? _c("v-list-item-title", [
                        _vm.price > 0.0
                          ? _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("payment.successMessagePrice", [
                                    _vm.$n(_vm.price, "currency", "de-DE"),
                                    _vm.feeAmount > 0
                                      ? _vm.$t(
                                          "payment.successMessagePriceAddon",
                                          [
                                            _vm.$n(
                                              _vm.feeAmount,
                                              "currency",
                                              "de-DE"
                                            ),
                                            _vm.$t(
                                              "payment." +
                                                _vm.paymentOption.toLowerCase()
                                            ),
                                          ]
                                        )
                                      : "",
                                    this.SessionData.club.name,
                                  ])
                                ),
                              },
                            })
                          : _c("div", [
                              _vm.type == _vm.TYPE_COURSES
                                ? _c("div", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "payment.successMessagePriceFree",
                                            [
                                              _vm.$t("common.article_des"),
                                              _vm.$t("common.label_courses"),
                                            ]
                                          )
                                        ) +
                                        " "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm.type == _vm.TYPE_HALLS
                                ? _c("div", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "payment.successMessagePriceFree",
                                            [
                                              _vm.$t("common.article_der"),
                                              _vm.$t("common.label_hall"),
                                            ]
                                          )
                                        ) +
                                        " "
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                      ])
                    : _c("v-list-item-title", [
                        _vm.price > 0.0
                          ? _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t(
                                    "payment.successMessageClubAccountingPrice",
                                    [_vm.$n(_vm.price, "currency", "de-DE")]
                                  )
                                ),
                              },
                            })
                          : _c("div", [
                              _vm.type == _vm.TYPE_COURSES
                                ? _c("div", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "payment.successMessagePriceFree",
                                            [
                                              _vm.$t("common.article_des"),
                                              _vm.$t("common.label_courses"),
                                            ]
                                          )
                                        ) +
                                        " "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm.type == _vm.TYPE_HALLS
                                ? _c("div", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "payment.successMessagePriceFree",
                                            [
                                              _vm.$t("common.article_der"),
                                              _vm.$t("common.label_hall"),
                                            ]
                                          )
                                        ) +
                                        " "
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                      ]),
                  _c(
                    "v-list-item-subtitle",
                    [
                      _c(
                        "v-icon",
                        {
                          staticClass: "mt-4",
                          attrs: { color: "success", size: "120" },
                        },
                        [_vm._v(" mdi-check-circle-outline ")]
                      ),
                      _c("v-spacer"),
                      _vm._v(
                        " " + _vm._s(_vm.$t("payment.successSubMessage")) + " "
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "template",
        { slot: "actionbuttons" },
        [
          _c(
            "v-row",
            {
              attrs: {
                justify: "space-around",
                align: "center",
                "no-gutters": "",
              },
            },
            [
              _c(
                "v-btn",
                {
                  staticClass: "ma-2",
                  style: _vm.showTwoActionLines ? "width: 95%" : "",
                  attrs: { color: "primary" },
                  on: { click: _vm.handleMyBookingsClick },
                },
                [_vm._v(_vm._s(_vm.$t("overview.tab_label_myBookings")))]
              ),
              !_vm.fromMyBookings
                ? _c(
                    "v-btn",
                    {
                      staticClass: "ma-2",
                      style: _vm.showTwoActionLines ? "width: 95%" : "",
                      attrs: { color: "primary" },
                      on: { click: _vm.handleGoToOverviewClick },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            _vm.type == _vm.TYPE_COURSES
                              ? "overview.details_header_backToCourseOverview"
                              : "overview.details_header_backToHallOverview"
                          )
                        )
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }